<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.pa_name}}</p>
        </div>
        <div class="weui-cell__ft">
          <span
            class="list-item-status"
            :class="{'warning':item.pa_status!='已禁用'}"
          >{{item.pa_status}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/finance/paymentspay_edit" />
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/paymentspay/list",
      params: {
        // number: 1,
        // size: 100
      }
    };
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "FinancePaymentspayEdit",
        params: {
          initData: Object.assign({}, item)
        }
      });
    }
  }
};
</script>